import { render } from "./PcAppAlert.vue?vue&type=template&id=0bfc01e5&scoped=true"
import script from "./PcAppAlert.vue?vue&type=script&lang=js"
export * from "./PcAppAlert.vue?vue&type=script&lang=js"

import "./PcAppAlert.vue?vue&type=style&index=0&id=0bfc01e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfc01e5"]])

export default __exports__